module.exports = __webpack_public_path__ + "img/card-ribbon-right-sm.f7ffeebe.svg";